<template>
  <section class="f-30">
    <m-img class="alive_fill" src="@/v2/pad/assets/images/30/1.png" v-ia />
    <div ref="bg" class="alive_bg">
      <div class="alive_small_title" v-ia>
        <div class="small_title f-center-title">Alive 壁纸</div>
        <div class="small_sub_title f-center-title">动静皆宜，好看又好玩</div>
      </div>
      <div
        class="alive_bg_mask"
        v-ia
        v-bg
        bg-url="@/v2/auto/assets/image/30/bg.jpg"
      >
        <div class="video_container f-select-center" ref="videoContainer">
          <div class="video_screen">
            <m-video
              ref="video"
              class="alive_video"
              disablepictureinpicture
              muted
              src="@/v2/auto/assets/video/30/0.mp4"
            ></m-video>
            <m-img class="mask_screen" src="@/v2/auto/assets/image/30/0.png" />
          </div>
          <replay @click="replayVideo($refs.video)" />
          <div class="title-content">
            <div class="bottom_title f-center-title">生长</div>
            <div class="bottom_sub_title f-center-sub-title">
              车辆充电时花朵逐渐绽放，耗电时逐渐闭合，让用户直观感受到能量的流动与变化
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import { replayVideo, videoPlayByVisibleArea } from '@/utils'
import replay from '@/components/replay.vue'
export default {
  components: {
    replay,
  },
  data() {
    return {
      preload_: true,
    }
  },
  methods: {
    replayVideo,
  },
  mounted() {
    videoPlayByVisibleArea(this.$refs.video)
  },
}
</script>
<style lang="less" scoped>
.f-30 {
  width: 100%;
  background-color: black;
  position: relative;

  .alive_fill {
    height: 100vh;
    width: 100%;
    object-fit: contain;
  }
  .alive_bg {
    position: relative;
    width: 100%;
    display: flex;
    margin-top: 200px;
    flex-direction: column;
    align-items: center;
    overflow: hidden;

    .alive_bg_mask {
      background-size: 100% 100%;
      background-position: top;
      background-repeat: no-repeat;
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
    }

    .alive_small_title {
      width: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      font-weight: 700;

      .small_title {
        background: radial-gradient(
          32.55% 65.56% at 49.68% 12.22%,
          #4e40be 0%,
          #9a8deb 100%
        );
        -webkit-background-clip: text;
        background-clip: text;
        color: transparent;
        line-height: 60px;
      }

      .small_sub_title {
        color: white;
      }
    }
    .video_container {
      height: auto;
      display: flex;
      flex-direction: column;
      justify-content: center;
      gap: 20px;
      margin-top: 100px;
      align-items: flex-end;
      color: white;
      background-size: 100% 100%;
      background-position: top;
      background-repeat: no-repeat;
      position: relative;
      .video_screen {
        border-radius: 20px;
        width: 100%;
        aspect-ratio: 1.6;
        overflow: hidden;
        position: relative;
        .alive_video {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
        .mask_screen {
          z-index: 1;
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          object-fit: cover;
          pointer-events: none;
        }
      }

      .title-content {
        margin-bottom: 100px;
        width: 100%;
        .bottom_title {
          margin-bottom: 16px;
          color: #ffffff;
          font-weight: 600;
          line-height: 66px;
          text-align: center;
        }

        .bottom_sub_title {
          color: #ffffffcc;
          text-align: center;
        }
      }
    }
  }
}
</style>
